'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'box-open-full';
var width = 640;
var height = 512;
var aliases = ["box-full"];
var unicode = 'f49c';
var svgPathData = 'M315.8 170.5c2.9-8.3 4.5-17.2 4.5-26.5 0-44.2-35.8-80-80-80-24.5 0-46.5 11-61.2 28.4l-47.1-26.9-9-5.1C149.2 23.8 192 0 240.3 0 274 0 305 11.6 329.5 30.9 340.7 12.4 361.1 0 384.3 0l64 0c35.1 0 63.7 28.3 64 63.4l-3.7 2.1-60.3 34.4 0-35.9-64 0 0 64-.9 0c.3 2.8 .5 5.7 .7 8.6l-63.8 36.5-4.5-2.6zm286.2 72.1c-13.5 9-31.3 6.4-41.8-5.5l0 117.5c0 23-12.4 44.3-32.4 55.7l-176 99.7c-19.6 11.1-43.5 11.1-63.1 0l-176-99.7C92.7 399 80.3 377.8 80.3 354.7l0-53.3-33-17.7c-23.4-12.5-32.2-41.7-19.6-65.1l48.4-89.9c4.1-7.5 11-13.1 19.2-15.5s17.1-1.4 24.5 2.7L320.3 227.4 520.8 116c14.6-8.1 32.9-3.6 42.2 10.2l48 72c9.8 14.7 5.8 34.6-8.9 44.4zM278.8 277.6l-161.7-89.8-25.4 47.2 165.8 88.8 21.3-46.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxOpenFull = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;